import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-penetration100120-page',
  templateUrl: './penetration100120-page.component.html',
  styleUrls: ['./penetration100120-page.component.scss']
})
export class Penetration100120PageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
